<template>
  <div
    class="p-5 box bg-blue-50 shadow-md"
    :class="{ 'bg-blue-200': props.cardType == 'to' }"
    v-for="item in props.items"
    :key="item.employee_id"
  >
    <div class="flex flex-row items-center mb-2">
      <div class="intro-x w-14 h-14 image-fit">
        <img
          :src="item.employee_image"
          alt=""
          class="rounded-full"
          @error="$h.imgError"
        />
      </div>
      <div class="pl-4">
        <div class="text-base font-bold">
          {{ getCardTypeName(props.cardType) }}
        </div>
        <div>
          {{ item.name }}
        </div>
      </div>
    </div>
    <div v-if="item.approve_status" class="space-y-2">
      <div><b>หมายเหตุ:</b> {{ item.comment }}</div>
      <div><b>วันที่:</b> {{ item.approve_date }}</div>
      <div>
        <BtnApprove
          :title="getOptionApproveName(item.approve_status)"
          :status="item.approve_status"
        />
      </div>
    </div>
    <div v-else>
      <div
        class="w-full py-4 mt-2 font-bold text-gray-500 text-lg text-center border-dotted border-2 border-gray-500 rounded-md"
      >
        รอพิจารณา
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useStore } from '@/store'
import { helper as $h } from '@/utils/helper'
import BtnApprove from '@/components/BtnApprove.vue'

export default defineComponent({
  name: 'card-memo',
  props: {
    items: Array,
    cardType: String
  },
  components: { BtnApprove },
  setup(props) {
    const store = useStore()
    const getOptionApproveName = val => {
      return store.getters['memo/getApproveName'](val)
    }
    const getCardTypeName = () => {
      if (props.cardType == 'to') {
        return 'เรียน'
      } else if (props.cardType == 'cc') {
        return 'ผ่าน'
      }
      return ''
    }
    return {
      props,
      getCardTypeName,
      getOptionApproveName,
      $h
    }
  }
})
</script>
